import Menu from "../NAVBAR/menu";
import logoMuseo from '../img/logomuseogrande.png';
import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import './prestamos.css'
import { getDatos2, subespecimen, Toast, getBochones } from "../../store/action";
import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2'
import axios from "axios"
import { BiPrinter } from "react-icons/bi";
import { useNavigate, Link } from "react-router-dom";
import { url } from '../../URL.js'
import { jsPDF } from "jspdf";
import { useTranslation } from "react-i18next"

export function Prestamos() {
    const navigate = useNavigate()
    let dispatch = useDispatch()
    let especimenes = useSelector((state) => state.especimenes)
    let bochones = useSelector((state) => state.bochones.data)
    let usuario = useSelector((state) => state.usuario)
    const [catalogo, setCatalogo] = useState()
    let espec = especimenes;
    let bochon = bochones;
    const { isAuthenticated, user } = useAuth0();
    const [prestamo, setPrestamo] = useState({ tipoprestamo: 'Préstamo' })
    let fecha = obtenerFecha()
    const [listapres, setListapres] = useState()
    const [prestamoFilter, setPrestamoFilter] = useState()
    const [numerosSort, setNumerosSort] = useState()
    const [numb, setNumb] = useState(0)
    const [espeSelect, setEspectSelect] = useState()
    const [numerosEspe, setNumerosEspe] = useState([])
    const [t, i18n] = useTranslation("global")

    function traerPrestamos() {
        axios.get(`${url}prestamosRoute/prestamos`)
            .then(res => setListapres(res.data))
    }
    useEffect(() => {
        dispatch(getDatos2())
        dispatch(getBochones())

        traerPrestamos()

    }, [numb])



    function obtenerFecha() {
        let fechaActual
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        if (month < 10) {
            fechaActual = year + '-0' + month + '-' + day /* day + '/0' + month + '/' + year */
        } else {
            fechaActual = year + '-' + month + '-' + day
        }
        if (day < 10) {
            fechaActual = year + '-0' + month + '-' + '0' + day
        }
        return fechaActual
    }
    function detallePrestamo(e, elemento) {
        let fecha1 = obtenerFecha()
        let put = { especimennumero: elemento.numeroespecimen, prestado: false }
        let update = { id: elemento.id, fechadevolucion: fecha1, devuelto: true }
        let idPrestamo = elemento.id
        if (elemento.devuelto) {
            const { value: formValues } = Swal.fire({
                title: `${elemento.tipoprestamo}`,
                html:
                    `<div class="modal-detalle-content">` +
                    `<div class="modal-row"><span class="modal-label">${t("LOAN_BY")}</span> <span class="modal-value">${elemento.emisor}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("RESEARCHER")}</span> <span class="modal-value">${elemento.investigador}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("MAIL")}</span> <span class="modal-value">${elemento.correo}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("CONT")}</span> <span class="modal-value">${elemento.contacto}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("INSTITUTION")}</span> <span class="modal-value">${elemento.institucion}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("SPECIMEN_NUM")}</span> <span class="modal-value">${elemento.tipoprestamo.includes("bochon") ? elemento.numeroespecimen.map(el => { return (el) }) : elemento.numeroespecimen.map(el => { return (subespecimen(el)) })}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("LOAN_DATE")}</span> <span class="modal-value">${elemento.fechaprestamo}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("EST_RETURN_DATE")}</span> <span class="modal-value">${elemento.fechadevolucionest}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("COMMENT")}</span> <span class="modal-value">${elemento.comentarios != null ? elemento.comentarios : t("NO_COMMENTS")}</span></div>` +
                    `</div>`,
                showCloseButton: true,
                showDenyButton: true,
                showConfirmButton: true,
                denyButtonText: t("VOLVER"),
                confirmButtonText: t("ELI"),
                preConfirm: () => {

                    return [
                        axios.delete(`${url}prestamosRoute/eliminarPrestamos?id=` + idPrestamo)
                            .then(res => {
                                if (res.status == 200) {
                                    Swal.fire(
                                        t("-PRESTA"),
                                        t("VOLVER"),
                                        'success'
                                    )
                                    setTimeout(() => { traerPrestamos() }, "1000")
                                    traerPrestamos()
                                } else { Swal.fire(t("SOMETHING_WRONG"), '', 'warning') }
                            })

                    ]
                }
            })
            if (formValues) {
                Swal.fire(JSON.stringify(formValues))
            }

        } else {
            const { value: formValues } = Swal.fire({
                title: `${elemento.tipoprestamo}`,
                html:
                    `<div class="modal-detalle-content">` +
                    `<div class="modal-row"><span class="modal-label">${t("LOAN_BY")}</span> <span class="modal-value">${elemento.emisor}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("RESEARCHER")}</span> <span class="modal-value">${elemento.investigador}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("MAIL")}</span> <span class="modal-value">${elemento.correo}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("CONT")}</span> <span class="modal-value">${elemento.contacto}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("INSTITUTION")}</span> <span class="modal-value">${elemento.institucion}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("SPECIMEN_NUM")}</span> <span class="modal-value">${elemento.tipoprestamo.includes("bochon") ? elemento.numeroespecimen.map(el => { return (el) }) : elemento.numeroespecimen.map(el => { return (subespecimen(el)) })}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("LOAN_DATE")}</span> <span class="modal-value">${elemento.fechaprestamo}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("EST_RETURN_DATE")}</span> <span class="modal-value">${elemento.fechadevolucionest}</span></div>` +
                    `<div class="modal-row"><span class="modal-label">${t("COMMENT")}</span> <span class="modal-value">${elemento.comentarios != null ? elemento.comentarios : t("NO_COMMENTS")}</span></div>` +
                    `</div>`,



                showCloseButton: true,
                showDenyButton: true,

                denyButtonText: t("VOLVER"),

                confirmButtonText: t("DEVO"),
                preConfirm: () => {
                    Swal.fire(
                        t("PREACT"),
                        t("VOLVER"),
                        'success'
                    )
                    return [
                        axios.put(`${url}prestamosRoute/prestamos`, update),
                        axios.put(`${url}modificarespre`, put),
                        setTimeout(() => { traerPrestamos() }, "1000"),
                        traerPrestamos(),

                    ]
                }
            })
            if (formValues) {
                Swal.fire(JSON.stringify(formValues))
            }
        }

    }

    //console.log(especimenes,"especimen")
    //console.log(bochon,"bochones")
    function changeInput(e) {
        setPrestamo({
            ...prestamo,
            [e.target.name]: e.target.value
        })
    }

    function submitPrestamo(e) {

        let obj = {
            emisor: user?.name,
            fechaprestamo: fecha,
            tipoprestamo: prestamo.tipoprestamo + "/" + catalogo,
            investigador: prestamo.investigador,
            correo: prestamo.correo,
            contacto: prestamo.contacto,
            numeroespecimen: numerosEspe,
            institucion: prestamo.institucion,
            comentarios: prestamo.comentarios,
            fechadevolucionest: prestamo.fechadevolucionest,

        }

        let investi = document.getElementById('investigador').value
        let put = { especimennumero: numerosEspe, prestado: true, catalog: catalogo }
        if (!numerosEspe) {
            Toast.fire({ icon: 'warning', title: t("-NUM") })

        }

        else {
            axios.post(`${url}prestamosRoute/prestamos`, obj)
                .then(res => { Toast.fire({ icon: 'success', title: t("+PRESTA") }) })
            axios.put(`${url}modificarespre`, put)
            traerPrestamos()
            setPrestamo(null)
            setNumb(numb + 1)
        }

    } let back = 'white'


    function filtrarPrestamo(e) {
        e.preventDefault()
        if (e.target.value.length === 0) {
            setPrestamoFilter(listapres)
        } else {
            if (!e.target.value.includes('-')) {
                //     console.log(e.target.value,listapres)

                let result = listapres?.filter(el => el.numeroespecimen.includes(e.target.value + '000'))

                setPrestamoFilter(result)
            } else {
                //  console.log(e.target.value)
                let result = listapres?.filter(el => el.numeroespecimen.includes(e.target.value.replace('-', '')))
                setPrestamoFilter(result)
            }

        }

    }

    function prestamoORconsulta(e) {
        setPrestamo({
            ...prestamo,
            tipoprestamo: e.target.value
        })
    }
    function filtrarEspecimen(e, value) {

        //  console.log()
        setNumerosEspe([...numerosEspe, e.target.value])
        if (e.target.value.length === 0) {
            setEspectSelect()
        }
        else {
            if (catalogo === "coleccion") {
                let especimenSelect = espec.filter(el => el.especimennumero === e.target.value)
                setEspectSelect(especimenSelect)

            } else {
                let bochonselect = bochon.filter(el => el.bochonnumero === e.target.value)
                setEspectSelect(bochonselect)
            }
        }

    }

    let style = {
        color: "green",
        fontStyle: "oblique"
    }
    function eliminarNumero(el, e) {
        e.preventDefault()
        let cambio = numerosEspe.filter(occ => occ !== el)
        setNumerosEspe(cambio)


    }
    let numeroEspecimenes = espec?.map(el => el.especimennumero)
    let numeroBochones = bochon?.map(el => el.bochonnumero)
    function SortArray(x, y) {
        if (Number(x) < Number(y)) { return -1; }
        if (Number(x) > Number(y)) { return 1; }
        return 0;
    }

    function imprimirPDF(e) {
        const params = listapres.find((el) => el.id === e);
        if (!params) return;

        const tipoprestamoRaw = String(params.tipoprestamo || "");
        const [tipoRaw, catalogRaw] = tipoprestamoRaw.split("/");
        const tipoNorm = (tipoRaw || "").toLowerCase();
        const catalogNorm = (catalogRaw || "").toLowerCase();
        const isConsulta = tipoNorm.includes("consulta");
        const isBochon = catalogNorm.includes("bochon") || tipoprestamoRaw.toLowerCase().includes("bochon");

        const tipoDisplay = isConsulta ? "Consulta" : "Préstamo";
        let coleccionDisplay = "Colección";
        if (isBochon) coleccionDisplay = "Bochones";
        else if (catalogNorm.includes("sinprepar")) coleccionDisplay = "Sin preparar";
        const ids = Array.isArray(params.numeroespecimen) ? params.numeroespecimen : [];
        const select = ids
            .map((idItem) => {
                if (isBochon) return bochones?.find((it) => it.bochonnumero === idItem);
                return especimenes?.find((it) => it.especimennumero === idItem);
            })
            .filter(Boolean);

        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 14;
        let y = 14;

        const drawHeader = () => {
            doc.addImage(logoMuseo, margin, 8, 46, 20);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(13);
            doc.setTextColor(35, 62, 50);
            doc.text(t("PDF_INSTITUTE"), margin + 50, 14);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);
            doc.setTextColor(60, 60, 60);
            doc.text(t("PDF_CATALOG"), margin + 50, 19);
            doc.setDrawColor(200, 210, 204);
            doc.line(margin, 25, pageWidth - margin, 25);
            y = 30;
        };

        const addPageIfNeeded = (neededHeight, redrawTableHeader = false) => {
            if (y + neededHeight <= pageHeight - 18) return;
            doc.addPage();
            drawHeader();
            if (redrawTableHeader) {
                drawTableHeader();
            }
        };

        const drawTitleBlock = () => {
            const rightText = `${t("PDF_DATE")} ${formato(fecha)}`;

            doc.setFillColor(237, 243, 239);
            doc.roundedRect(margin, y, pageWidth - margin * 2, 14, 2, 2, "F");
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10.5);
            doc.setTextColor(35, 62, 50);
            doc.text(`Tipo: ${tipoDisplay}`, margin + 3, y + 6);
            doc.text(`Colección: ${coleccionDisplay}`, margin + 3, y + 11.5);

            doc.setFont("helvetica", "normal");
            doc.setTextColor(55, 55, 55);
            doc.text(rightText, pageWidth - margin - 2, y + 6, { align: "right" });
            y += 18;
        };

        const drawField = (label, value) => {
            const labelWidth = 42;
            const valueWidth = pageWidth - margin * 2 - labelWidth;
            const valueText = value && String(value).trim().length > 0 ? String(value) : "-";
            const lines = doc.splitTextToSize(valueText, valueWidth);
            const rowHeight = Math.max(6, lines.length * 4.5 + 2);

            addPageIfNeeded(rowHeight + 2);

            doc.setFont("helvetica", "bold");
            doc.setFontSize(9.5);
            doc.setTextColor(90, 90, 90);
            doc.text(label, margin, y + 4);

            doc.setFont("helvetica", "normal");
            doc.setTextColor(30, 30, 30);
            doc.text(lines, margin + labelWidth, y + 4);

            y += rowHeight;
        };

        const tableCols = {
            idx: 10,
            nro: 62,
            tipo: 24,
            taxon: pageWidth - margin * 2 - 10 - 62 - 24,
        };

        const drawTableHeader = () => {
            doc.setFillColor(237, 243, 239);
            doc.rect(margin, y, pageWidth - margin * 2, 8, "F");
            doc.setDrawColor(210, 220, 214);
            doc.rect(margin, y, pageWidth - margin * 2, 8);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.setTextColor(35, 62, 50);
            doc.text("#", margin + 2, y + 5.5);
            doc.text("NRO", margin + tableCols.idx + 2, y + 5.5);
            doc.text("TIPO", margin + tableCols.idx + tableCols.nro + 2, y + 5.5);
            doc.text("GENERO / ESPECIE", margin + tableCols.idx + tableCols.nro + tableCols.tipo + 2, y + 5.5);
            y += 9;
        };

        drawHeader();
        drawTitleBlock();

        drawField(t("PDF_RESEARCHER"), params.investigador);
        drawField(t("PDF_INSTITUTION"), params.institucion);
        drawField(t("PDF_ENDORSEMENT"), params.emisor);
        drawField(t("PDF_RETURN_DATE"), formato(params?.fechadevolucionest || ""));

        y += 2;
        addPageIfNeeded(14, true);
        drawTableHeader();

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9.3);

        select.forEach((item, idx) => {
            const nro = isBochon
                ? `${t("PDF_BOCHON_PREFIX")} ${item.bochonnumero}`
                : `${t("PDF_SPECIMEN_PREFIX")} ${subespecimen(item.especimennumero)}`;
            const tipo = isBochon ? "Bochon" : "Especimen";
            const taxon = `${item.genero || "-"} / ${item.especie || "-"}`;

            const nroLines = doc.splitTextToSize(nro, tableCols.nro - 3);
            const tipoLines = doc.splitTextToSize(tipo, tableCols.tipo - 3);
            const taxonLines = doc.splitTextToSize(taxon, tableCols.taxon - 3);
            const linesCount = Math.max(nroLines.length, tipoLines.length, taxonLines.length);
            const rowHeight = Math.max(7, linesCount * 4.2 + 2);

            addPageIfNeeded(rowHeight + 2, true);

            doc.setDrawColor(230, 235, 231);
            doc.rect(margin, y - 1, pageWidth - margin * 2, rowHeight);
            doc.text(String(idx + 1), margin + 2, y + 3);
            doc.text(nroLines, margin + tableCols.idx + 2, y + 3);
            doc.text(tipoLines, margin + tableCols.idx + tableCols.nro + 2, y + 3);
            doc.setFont("helvetica", "italic");
            doc.text(taxonLines, margin + tableCols.idx + tableCols.nro + tableCols.tipo + 2, y + 3);
            doc.setFont("helvetica", "normal");

            y += rowHeight + 1;
        });

        y += 3;
        const obsTitle = t("PDF_OBSERVATIONS");
        const obsText = params.comentarios && String(params.comentarios).trim().length > 0
            ? String(params.comentarios)
            : t("PDF_NO_OBSERVATIONS");
        const obsLines = doc.splitTextToSize(obsText, pageWidth - margin * 2 - 4);
        const obsHeight = Math.max(14, obsLines.length * 4.5 + 5);

        addPageIfNeeded(obsHeight + 14);

        doc.setFont("helvetica", "bold");
        doc.setTextColor(35, 62, 50);
        doc.text(obsTitle, margin, y);
        y += 3;

        doc.setFont("helvetica", "normal");
        doc.setTextColor(30, 30, 30);
        doc.roundedRect(margin, y, pageWidth - margin * 2, obsHeight, 2, 2);
        doc.text(obsLines, margin + 2, y + 5);

        const signY = pageHeight - 26;
        doc.setDrawColor(120, 130, 125);
        doc.line(margin + 8, signY, margin + 78, signY);
        doc.line(pageWidth - margin - 78, signY, pageWidth - margin - 8, signY);
        doc.setFontSize(9.5);
        doc.text(params.emisor || "-", margin + 10, signY + 6);
        doc.text(params.investigador || "-", pageWidth - margin - 76, signY + 6);

        const suffix = isConsulta ? t("PDF_FILENAME_CONSULT") : t("PDF_FILENAME_LOAN");
        doc.save(`${suffix}${params.investigador || "documento"}.pdf`);
    }
    // let numerosSort = numeroEspecimenes?.sort(SortArray12)

    function formato(texto) {
        return texto.replace(/^(\d{4})-(\d{2})-(\d{2}||\d{1})$/g, '$3-$2-$1');
    }
    function SortArray(x, y) {
        if (x.fechaprestamo > y.fechaprestamo) { return -1; }
        if (x.fechaprestamo < y.fechaprestamo) { return 1; }
        return 0;
    }
    function SortArray12(x, y) {
        if (Number(x) < Number(y)) { return -1; }
        if (Number(x) > Number(y)) { return 1; }
        return 0;
    }
    let listPrestamosOrder = listapres?.sort(SortArray)
    let prestamoFilterOrder = prestamoFilter?.sort(SortArray)
    function SelecCatalogo(value) {
        setNumerosEspe([])
        if (value === 'coleccion') {
            //  console.log(value)
            setCatalogo("coleccion")
            setNumerosSort(numeroEspecimenes?.sort(SortArray12))
        } else {
            setCatalogo("bochon")
            setNumerosSort(numeroBochones?.sort(SortArray12))
        }
    }
    // console.log(numerosSort, "numeros")

    return (
        <div className='container34'>

            <datalist id='prestamo-numero-especimen'>
                {
                    listapres?.map(eleme => { return <option>{eleme.numeroespecimen}</option> })
                    //especiefiltrada?.forEach(ele => {return <option>{ele}</option>})

                }

            </datalist>
            <datalist id='numeroespecimen'>
                {
                    espec?.map(eleme => { return <option>{eleme.especimennumero}</option> })
                    //especiefiltrada?.forEach(ele => {return <option>{ele}</option>})

                }

            </datalist>
            <Menu activo={4} />
            <div className="contenido34">
                <div className="cabecera">
                    <div className="apre">
                        {t("PRELIS")}
                    </div>
                </div>
                <div className='cont'>
                    <div className='crear-prest'>
                        <div className="cab-pres">
                            <h4 className="hhh">{t("INPRE")}</h4>
                        </div>

                        <form type='submit' onSubmit={(e) => { submitPrestamo(e) }} className='formulario-prestamo'>
                            <div className='form-prest'>
                                <div className='conte-div'>
                                    <label>{t("TYPE")}:</label>
                                    <select className="sdsd" onChange={(e) => prestamoORconsulta(e)} required>
                                        <option >{t("SELECT_OPTION")}</option>
                                        <option value='Préstamo' selected>{t("LOAN_OPTION")}</option>
                                        <option value='Consulta'>{t("CONSULTATION_OPTION")}</option>
                                    </select>
                                </div><div className='conte-div'>
                                    <label>{t("COLLECTION_LABEL")}</label>
                                    <select className="sdsd" onChange={(e) => SelecCatalogo(e.target.value)} required>
                                        <option >{t("SELECT_OPTION")}</option>
                                        <option value='coleccion'>{t("COLLECTION_OPTION")}</option>
                                        <option value='sinpreparar'>{t("UNPREPARED_OPTION")}</option>
                                    </select>
                                </div>
                                <div className="conte-div">
                                    <label>{t("INVES")}:</label>
                                    <input type='text' required name='investigador' id='investigador' className="sdsd" onChange={(e) => { changeInput(e) }} />
                                </div>
                                <div className="conte-div">
                                    <label>{t("MAIL")}:</label>
                                    <input className="sdsd" type='text' name='correo' id='correo' onChange={(e) => { changeInput(e) }} />
                                </div>
                                <div className="conte-div">
                                    <label>{t("CONT")}:</label>
                                    <input className="sdsd" type='text' name='contacto' id='contacto' onChange={(e) => { changeInput(e) }} />
                                </div>
                                <div className="conte-div">
                                    <label>{t("INSTI")}:</label>
                                    <input className="sdsd" type='text' name='institucion' id='institucion' onChange={(e) => { changeInput(e) }} />
                                </div>
                                <div className="conte-div2">
                                    <label>{t("ESPECNRO")}:</label>
                                    <select onChange={(e) => { filtrarEspecimen(e) }} required className="sdsd">
                                        <option value=''>{t("SEL")}</option>
                                        {
                                            catalogo === "coleccion" ?
                                                numerosSort?.map(eleme => { return <option value={eleme}>{subespecimen(eleme)}</option> })
                                                :
                                                numerosSort?.map(eleme => { return <option value={eleme}>{eleme}</option> })
                                        }
                                    </select>
                                    <div className='gen-selected'>
                                        {
                                            espeSelect ? <p style={style}>{espeSelect[0]?.genero + " " + espeSelect[0]?.especie}</p> : null
                                        }
                                    </div>
                                    {/* <input  className="sdsd" type='text' list='numeroespecimen' id='especimennumero'name='numeroespecimen' required onChange={(e)=> {filtrarEspecimen(e)}}/> */}
                                </div>
                                <div className='numeros-de-especimen'>
                                    {catalogo === "coleccion" ?
                                        (numerosEspe ? numerosEspe?.map(el => { return <div onClick={(e) => eliminarNumero(el, e)} className='caca-prestamos'><span tooltip="click para eliminar" >{subespecimen(el)}</span></div> }) : null)
                                        :
                                        (numerosEspe ? numerosEspe?.map(el => { return <div onClick={(e) => eliminarNumero(el, e)} className='caca-prestamos'><span tooltip="click para eliminar" >{el}</span></div> }) : null)
                                    }
                                </div>
                                <div className="conte-div">
                                    <label >{t("EST")}</label>
                                    <input className="sdsd" type='date' required name='fechadevolucionest' id='fechadevolucionest' onChange={(e) => { changeInput(e) }} />
                                </div>
                                <p>{t("COMENT")}</p>
                                <textarea type='text' className='text-pres' placeholder={t("DELIVERY_DETAIL_PLACEHOLDER")} name='comentarios' onChange={(e) => { changeInput(e) }} />
                                <button type="submit" className='boton-prest'>{t("+PRES")}</button>
                            </div>
                        </form>
                    </div>
                    <div className='lista-prest'>
                        <div className='buscar-prestamo'>

                            <h4 className="hhh">{t("BUS")}:</h4>
                            <input type="number" id='num-prestamo' placeholder={t("INGRE")} onChange={(e) => { filtrarPrestamo(e) }} className='buscar-prestamo-input'></input>

                        </div>


                        <div id="main-container234">
                            {
                                !listapres ?
                                    <div className='spiner'>
                                        <div className="spinner-border text-success" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                    :
                                    <table className="rwd_auto fontsize2 papa1"> {/* Aplica la clase 'papa1' a la tabla */}
                                        <thead className="tabli-headP">
                                            <tr className="trHead">
                                                <th width='17%'>{t("FEPRE")}</th>
                                                <th width='13%'>{t("TYPE")}</th>
                                                <th width='15%'>{t("ESPECNRO")}</th>
                                                <th width='15%'>{t("INVES")}</th>
                                                <th width='15%'>{t("FEDEV")}</th>
                                                <th width='6%'>{t("DEVO")} </th>
                                                <th width='7%'>PDF</th> {/* Nueva columna para el icono de impresión */}
                                            </tr>
                                        </thead>
                                        <tbody className="bodyPres">
                                            {
                                                prestamoFilterOrder?.length > 0 ?
                                                    prestamoFilterOrder?.map((elemento) => {
                                                        let back = elemento.fechadevolucionest < fecha && elemento.devuelto === false ? 'tr2Rojo' : ''; // Clase condicional para filas rojas

                                                        var cont = 0;
                                                        return (
                                                            <tr key={elemento?.id} onClick={(e) => detallePrestamo(e, elemento)} className={back}>
                                                                <td width='17%'>{formato(elemento?.fechaprestamo)}</td>
                                                                <td width='15%'>{elemento.tipoprestamo}</td>
                                                                <td width='17%'>
                                                                    {
                                                                        elemento.tipoprestamo.includes("bochon") ?
                                                                            elemento.especimennumero
                                                                            :
                                                                            (elemento?.numeroespecimen.map(el => {
                                                                                cont++;
                                                                                return cont < elemento?.numeroespecimen.length ? subespecimen(el) + " / " : subespecimen(el);
                                                                            }))
                                                                    }
                                                                </td>
                                                                <td width='19%'>{elemento?.investigador}</td>
                                                                <td width='15%'>{formato(elemento?.fechadevolucionest)}</td>
                                                                {elemento?.fechadevolucion ? <td width='11%'>{formato(elemento?.fechadevolucion)}</td> : <td width='10%'>{t("PENDING")}</td>}
                                                                <td onClick={(e) => {
                                                                    e.stopPropagation(); // Evita que el evento se propague a la fila
                                                                    imprimirPDF(elemento?.id)
                                                                }}>
                                                                    <BiPrinter fontSize='20px' />
                                                                </td>

                                                            </tr>
                                                        );
                                                    })
                                                    :
                                                    listPrestamosOrder?.map((elemento) => {
                                                        let back = elemento?.fechadevolucionest < fecha && elemento?.devuelto === false ? 'tr2Rojo' : '';

                                                        var cont = 0;
                                                        return (
                                                            <tr key={elemento?.id} onClick={(e) => detallePrestamo(e, elemento)} className={back}>
                                                                <td width='17%'>{formato(elemento?.fechaprestamo)}</td>
                                                                <td width='13%'>{elemento.tipoprestamo}</td>
                                                                <td width='17%'>
                                                                    {
                                                                        elemento.tipoprestamo.includes("bochon") ?
                                                                            (elemento?.numeroespecimen.map(el => {
                                                                                cont++;
                                                                                return cont < elemento?.numeroespecimen.length ? el + " / " : el;
                                                                            }))
                                                                            :
                                                                            (elemento?.numeroespecimen.map(el => {
                                                                                cont++;
                                                                                return cont < elemento?.numeroespecimen.length ? subespecimen(el) + " / " : subespecimen(el);
                                                                            }))
                                                                    }
                                                                </td>
                                                                <td width='18%'>{elemento?.investigador}</td>
                                                                <td width='15%'>{formato(elemento?.fechadevolucionest)}</td>
                                                                {elemento?.fechadevolucion ? <td width='10%'>{formato(elemento?.fechadevolucion)}</td> : <td width='8%'>{t("PENDING")}</td>}
                                                                <td onClick={(e) => {
                                                                    e.stopPropagation(); // Evita que el evento se propague a la fila
                                                                    imprimirPDF(elemento?.id)
                                                                }}>
                                                                    <BiPrinter fontSize='20px' />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                            }
                                        </tbody>
                                    </table>
                            }
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
